import { Children } from 'react';
import { TextWithTitleTooltip } from '@library/components/tooltip/templates/TextWithTitleTooltip';
import type { TooltipProps } from '@library/types/tooltip';
import { classNames } from '@library/utils';
import { useTooltip } from '@library/hooks/useTooltip';

export const Tooltip = ({
  children,
  childClassName = 'relative inline-block cursor-default',
  className = undefined,
  position = 'above',
  text = undefined,
  title = undefined
}: TooltipProps) => {
  const {
    showTooltip,
    tooltipPosition,
    tooltipRef,
    triggerAttributes,
    triggerRef
  } = useTooltip({ position, text });
  const [triggerChild, tooltipContent] = Children.toArray(children);

  return (
    <>
      <div ref={triggerRef} className={childClassName} {...triggerAttributes}>
        {triggerChild}
      </div>
      <div
        data-testid="Tooltip"
        ref={tooltipRef}
        style={{
          top: `${tooltipPosition.top}px`,
          left: `${tooltipPosition.left}px`
        }}
        className={classNames(
          'border-soFresh-140 bg-soFresh-110 text-soClean-100 fixed z-50 rounded-md border p-3 text-xs',
          showTooltip ? 'visible' : 'invisible',
          className ?? ''
        )}
      >
        {text ? (
          <TextWithTitleTooltip text={text} title={title} />
        ) : (
          tooltipContent
        )}
      </div>
    </>
  );
};
